import React from 'react';

import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';

import CloseIcon from '@mui/icons-material/Close';
import { color } from '../../style/color';
import { DialogActions } from '@mui/material';

const updateItems = [
  {
    title: 'Our role in handling your data',
    description:
      'We have clarified when we act as a data controller and when we act as a data processor, depending on the services we provide.',
  },
  {
    title: 'International data transfers',
    description:
      'We have updated this section to explain how we may transfer your data outside the UK and the safeguards we use, such as approved contractual mechanisms.',
  },
  {
    title: 'Complaints process',
    description:
      'We have added information about how you can raise a complaint with us, in line with new requirements under the Data (Use and Access) Act 2025.',
  },
];

export const PrivacyPolicyUpdateModal = ({ isOpen, onClose }) => {
  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      sx={{
        '& .MuiDialog-container': {
          alignItems: 'flex-start',
        },
      }}
      PaperProps={{
        sx: {
          borderRadius: 2,
          overflow: 'hidden',
          mt: 2,
        },
      }}
    >
      <DialogTitle
        sx={{
          pr: 6,
          py: 2,
          fontSize: '1.25rem',
          fontWeight: 700,
          color: color.brandDarkBlue,
          borderBottom: `1px solid ${color.smoke}`,
        }}
      >
        We've updated our Privacy Policy
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{ position: 'absolute', right: 8, top: 8, color: color.gray }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent
        sx={{
          px: { xs: 2.5, sm: 3.5 },
          py: 3,
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'flex-start',
          alignItems: 'flex-start',
          gap: '20px',
          flex: 'auto'
        //   overflowY: 'scroll',
        }}
      >
        <Typography
          sx={{
            mb: 3,
            fontSize: '1rem',
            lineHeight: 1.65,
            textAlign: 'left',
            color: color.black,
          }}
        >
          We've made important updates to our Privacy Policy and Cookie Policy to improve
          transparency and reflect recent legal requirements.
        </Typography>

        <Box>
            <Typography
            sx={{
                fontSize: '1.05rem',
                fontWeight: 700,
                color: color.brandDarkBlue,
                textAlign: 'left',
                gap: 0,
                mb: '5px'
            }}
            >
            What's changed?
            </Typography>

            <Box sx={{ mb: 3 }}>
            {updateItems.map((item) => (
                <Box
                key={item.title}
                sx={{
                    display: 'flex',
                    alignItems: 'flex-start',
                    gap: 1.5,
                    mb: 2.25,
                }}
                >
                <Box
                    sx={{
                    width: 8,
                    height: 8,
                    borderRadius: '50%',
                    backgroundColor: color.brandDarkGreen,
                    mt: '9px',
                    flexShrink: 0,
                    mr: '10px',
                    }}
                />
                <Box>
                    <Typography
                    sx={{
                        fontSize: '0.98rem',
                        lineHeight: 1.5,
                        fontWeight: 700,
                        color: color.black,
                        textAlign: 'left',
                        mb: 0.5,
                    }}
                    >
                    {item.title}
                    </Typography>
                    <Typography
                    sx={{
                        fontSize: '0.97rem',
                        lineHeight: 1.55,
                        color: color.black,
                        textAlign: 'left',
                    }}
                    >
                    {item.description}
                    </Typography>
                </Box>
                </Box>
            ))}
            </Box>

        </Box>
        <Box>

            <Typography
            sx={{
                fontSize: '1.05rem',
                fontWeight: 700,
                color: color.brandDarkBlue,
                textAlign: 'left',
                mb: '5px'
            }}
            >
            What this means for you
            </Typography>
            <Typography
            sx={{
                mb: '10px',
                fontSize: '0.97rem',
                lineHeight: 1.6,
                color: color.black,
                textAlign: 'left',
            }}
            >
            These updates do not change how we protect your personal data, but they provide
            clearer information about how we use it and your rights.
            </Typography>

            <Typography sx={{ mb: '10px', fontSize: '0.97rem', lineHeight: 1.6, textAlign: 'left' }}>
            Read the updated Privacy Policy{' '}
            <Link
                href="/privacy-policy"
                target="_blank"
                rel="noopener noreferrer"
                underline="always"
                sx={{ color: color.brandDarkBlue }}
            >
                on our website
            </Link>
            .
            </Typography>

            <Typography sx={{ fontSize: '0.95rem', lineHeight: 1.6, color: color.black, textAlign: 'left' }}>
            If you have any questions, please contact us at{' '}
            <Link
                href="mailto:customerservicesmanager@integrar.services"
                sx={{ color: color.brandDarkBlue }}
            >
                customerservicesmanager@integrar.services
            </Link>
            .
            </Typography>
        </Box>
    
      </DialogContent>
      <DialogActions>

            <Button
            variant="contained"
            color="button"
            onClick={onClose}
            sx={{
                minWidth: 150,
                color: color.white,
                borderRadius: '10px',
                textTransform: 'none',
                fontWeight: 600,
                ml: 1,
            }}
            >
            Acknowledge
            </Button>
      </DialogActions>
    </Dialog>
  );
};